export default "__VITE_ASSET__9017d97e__"